export const INFRA_LISTING_TYPE_ITEMS = [
  {
    id: "property",
    name: "Property",
    description: "Office, warehouse, factory, land",
    imagePath: "/images/infrastructure-leasing/listing-types/property.png",
  },
  {
    id: "machinery",
    name: "Machinery / Asset",
    description: "Equipment, machinery, infrastructure",
    imagePath: "/images/infrastructure-leasing/listing-types/machinery.png",
  },
];

export function mapFacilityType(row) {
  return {
    id: row.facility_type_id,
    name: row.facility_type,
    imagePath: row.image_path || null,
  };
}

export function mapFacilitySubType(row) {
  return {
    id: row.facility_sub_type_id,
    name: row.facility_sub_type,
    imagePath: row.image_path || null,
  };
}

export function mapFacilitySubSubType(row) {
  return {
    id: row.facility_sub_sub_type_id,
    name: row.facility_sub_sub_type,
    imagePath: row.image_path || null,
  };
}

export function getInfraBrowseDepth(applied) {
  if (applied.module !== "infra") return -1;
  if (!applied.infraType) return 0;
  if (!applied.infraCategory) return 1;
  if (!applied.infraSubCategory) return 2;
  if (applied.infraType === "machinery" && !applied.infraSubSubCategory) return 3;
  return 4;
}

export function buildInfraListingsHref(applied) {
  const next = new URLSearchParams();
  if (applied.infraType) next.set("type", applied.infraType);
  if (applied.infraCategory) next.set("assetCategory", applied.infraCategory);
  if (applied.infraSubCategory) next.set("subCategory", applied.infraSubCategory);
  if (applied.infraSubSubCategory) next.set("subSubCategory", applied.infraSubSubCategory);
  const qs = next.toString();
  return qs ? `/infrastructure-leasing/listings?${qs}` : "/infrastructure-leasing/listings";
}

export function buildMarketplaceInfraBrowseHref(params = {}) {
  const next = new URLSearchParams();
  next.set("module", "infra");
  const type = params.infraType || params.type;
  if (type) next.set("infraType", type);
  if (params.infraCategory || params.assetCategory) {
    next.set("infraCategory", String(params.infraCategory || params.assetCategory));
  }
  if (params.infraSubCategory || params.subCategory) {
    next.set("infraSubCategory", String(params.infraSubCategory || params.subCategory));
  }
  if (params.infraSubSubCategory || params.subSubCategory) {
    next.set("infraSubSubCategory", String(params.infraSubSubCategory || params.subSubCategory));
  }
  return `/marketplace/products?${next.toString()}`;
}

export function buildInfraListingsHrefFromBrowsePath(browsePath = {}) {
  const next = new URLSearchParams();
  if (browsePath.type) next.set("type", browsePath.type);
  if (browsePath.assetCategory) next.set("assetCategory", browsePath.assetCategory);
  if (browsePath.subCategory) next.set("subCategory", browsePath.subCategory);
  if (browsePath.subSubCategory) next.set("subSubCategory", browsePath.subSubCategory);
  const qs = next.toString();
  return qs ? `/infrastructure-leasing/listings?${qs}` : "/infrastructure-leasing/listings";
}

export function infraListingTypeLabel(infraType) {
  if (infraType === "machinery") return "Machinery / Asset";
  if (infraType === "property") return "Property";
  return null;
}
